import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const LIFE_MS = 6500;
const SPAWN_MS = 1100;

const ago = (iso) => {
  if (!iso) return "";
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  return m < 1 ? "just now" : m < 60 ? `${m}m ago` : `${Math.round(m / 60)}h ago`;
};

function Tag({ tag }) {
  const { item, x, y } = tag;
  const chg = item.change_pct;
  return (
    <div className="absolute scan-tag flex items-center gap-2 rounded-full border border-violet-300/20 bg-black/30 backdrop-blur-sm px-3 py-1 text-xs text-white/80 tabular-nums"
         style={{ left: `${x}%`, top: `${y}%` }} data-testid="scan-tape-tag">
      <span className="font-semibold text-white/90">{item.symbol}</span>
      <span className="h-1 w-8 rounded-full bg-white/10 overflow-hidden"><span className="block h-full bg-violet-300/80" style={{ width: `${item.score}%` }} /></span>
      <span className="text-violet-200">{item.score}</span>
      {typeof chg === "number" && <span className={chg >= 0 ? "text-emerald-300/80" : "text-red-300/80"}>{chg >= 0 ? "+" : ""}{chg.toFixed(1)}%</span>}
    </div>
  );
}

export default function ScanTape() {
  const [feed, setFeed] = useState(null);
  const [tags, setTags] = useState([]);
  const idx = useRef(0);
  const tagsRef = useRef([]);

  useEffect(() => {
    const load = () => axios.get(`${BACKEND_URL}/api/public/scan-tape`).then((r) => setFeed(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const items = feed?.items || [];
    if (!items.length) return undefined;
    const t = setInterval(() => {
      const item = items[idx.current % items.length];
      idx.current += 1;
      const live = tagsRef.current.filter((p) => Date.now() - p.born < LIFE_MS);
      let x = 0;
      let y = 0;
      for (let i = 0; i < 20; i += 1) {
        x = 12 + Math.random() * 56;
        y = 12 + Math.random() * 66;
        if (live.every((p) => Math.abs(p.x - x) > 22 || Math.abs(p.y - y) > 9)) break;
      }
      const tag = { id: `${idx.current}-${item.symbol}`, item, x, y, born: Date.now() };
      tagsRef.current = [...live, tag];
      setTags(tagsRef.current);
    }, SPAWN_MS);
    return () => clearInterval(t);
  }, [feed]);

  if (!feed?.items?.length) return null;
  return (
    <div className="pointer-events-none absolute inset-y-0 right-0 w-[42%] hidden min-[1440px]:block" aria-hidden="true" data-testid="scan-tape">
      {tags.map((t) => <Tag key={t.id} tag={t} />)}
      <div className="absolute bottom-24 right-10 text-xs text-white/45" data-testid="scan-tape-caption">
        Live scan · {feed.universe_size?.toLocaleString()} tickers · updated {ago(feed.scanned_at)}
      </div>
    </div>
  );
}
